import { bindable, BindingMode, watch } from 'aurelia';
import flatpickr from "flatpickr";
import { english } from "flatpickr/dist/l10n/default.js"
import { Estonian } from "flatpickr/dist/l10n/et.js"
import { Russian } from "flatpickr/dist/l10n/ru.js"

export class DateFilter {

    @bindable({ mode: BindingMode.twoWay }) selected = "";
    @bindable class = "";
    
    default = "";
    isMobile = false;
    mediaQuery = null;
    
    RESOURCE_BASE_URL = aurelia_options.resourceBaseUrl;
    aurelia_options = aurelia_options;

    constructor() {}

    @watch('isMobile')
    isMobileChanged() {
        this.initCalendar();
    }

    binding() {
        this.default = this.selected;
    }

    attached() {
        this.mediaQuery = window.matchMedia('(min-width: 900px)');
        this.isMobile = !this.mediaQuery.matches;
        this.mediaQuery.addEventListener('change', this.onMatchMediaChange);
        this.initCalendar();
    }

    detached() {
        this.mediaQuery.removeEventListener('change', this.onMatchMediaChange);
    }
    
    initCalendar() {
        let selector = '#' + (this.isMobile ? 'period-from-mobile-filter' : 'period-from-filter')
        english.firstDayOfWeek = 1;
        let localeFp = Estonian;
        switch (this.aurelia_options.language) {
            case 'ru':
                localeFp = Russian;
                break;
            case 'et':
                localeFp = Estonian;
                break;
            case 'en':
            default:
                localeFp = english;
        }
        flatpickr(selector, {
            showMonths: this.isMobile ? 1 : 2,
            mode: "single",
            minDate: new Date(Date.now()).toISOString().substring(0, 10), //"today"
            altFormat: "d.m.Y",
            inline: true,
            locale: localeFp,
            defaultDate: this.selected,
            onChange: (selectedDates, dateStr, instance) => {
                this.selected = dateStr;
            },
            prevArrow: `<div class="size-8 lmt-rotate-180 bg-current" style="mask-image: url('${this.RESOURCE_BASE_URL + '/images/icon-arrow.svg'}')"></div>`,
            nextArrow: `<div class="size-8 bg-current" style="mask-image: url('${this.RESOURCE_BASE_URL + '/images/icon-arrow.svg'}')"></div>`,
        });
    }

    onMatchMediaChange = (e) => {
        this.isMobile = !e.matches;
    };

    resetFilter() {
        this.selected = this.default;
    }

    openCloseFilter() {
        document.querySelector('#date-selection-dropdown')?.dispatchEvent(new CustomEvent('e-toggle'));
    }
}
